import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import axios from 'axios';
import LazyLoad, { lazyload } from 'react-lazyload';
lazyload({
  width: '100%',
});
const Team = props => {
  const [members, setMembers] = useState([]);
  const [cssRule, setCSSRule] = useState('');
  const getTeamMembers = () => {
    const url = 'https://admin.weprodigi.com/api/team/get-members';
    axios
      .get(url)
      .then(response => {
        setMembers(response.data);
      })
      .catch(error => {
        console.error('There was an error!', error);
      });
  };
  useEffect(() => {
    getTeamMembers();
  }, []);
  return (
    <>
      <Head>
        <title>Meet the Prodigi Team | Innovators in Digital Experience</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/team" />
        <meta
          name="description"
          content="Meet the creative minds behind Prodigi. Our dedicated team of professionals is committed to delivering exceptional digital marketing solutions."
        />
      </Head>
      <main>
        <div className="intro relative w-full h-600 md:h-700    MontserratArm">
          <style global jsx>{`
            ::selection {
              background: #670f7a;
              color: white;
            }
            .team_main {
              background: url('/images/team/Team-header.webp');
              background-attachment: fixed;
              //background-repeat: no-repeat;
              background-size: cover;
              overflow: hidden;
            }
            .element-image {
              background-position: center;
              background-repeat: no-repeat;
              cursor: pointer;
              transition: all 1s;
              border-radius: 5px;
              position: absolute;
              top: 0;
              background-size: cover;
            }
            @media screen and (max-width: 768px) {
              .team_main {
                background-position: 451px;
                background-attachment: unset;
              }
              .text-16 {
                font-size: 14px;
              }
            }
            .element-hover {
              opacity: 0;
              animation-fill-mode: forwards;
              animation-iteration-count: infinite;
            }
            .element-image:hover .element-hover {
              animation-play-state: paused;
              opacity: 1 !important;
              transition: all 1s;
            }
            .bottom-gradient {
              width: 100%;
              text-align: center;
              position: absolute;
              bottom: 0;
              background: linear-gradient(180deg, rgba(103, 15, 122, 0) 0%, #670f7a 100%);
              border-radius: 5px;
              height: 80px;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
            }
            .perspective-1000 {
              perspective: 1000px;
              display: inline-flex;
              width: 154px;
              height: 40px;
            }
            .perspective-1000 a {
              transform-style: preserve-3d;
              transform: translateZ(-0px);
              transition: transform 0.25s;
            }
            span.contact a:before,
            span a:after {
              position: absolute;
              content: 'Find Us';
              height: 40px;
              width: 154px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: 2px solid #8dc63f;
              box-sizing: border-box;
              border-radius: 5px;
              color: #fff;
              font-size: 18px;
              overflow: hidden;
            }
            span a:before {
              background: #8dc63f;
              transform: rotateY(0deg) translateZ(15px);
            }
            span a:after {
              font-weight: 400;
              color: #8dc63f;
              transform: rotateX(90deg) translateZ(15px);
            }
            span a:hover {
              transform: translateZ(-15px) rotateX(-90deg);
            }
            .icon-part {
              position: absolute;
              right: 1px;
              z-index: 12;
              padding: 5px;
              background: white;
              border-radius: 5px;
              width: 31px;
              height: 31px;
              display: flex;
              align-items: center;
              cursor: pointer;
              flex-wrap: wrap;
              overflow: hidden;
              transition: all 0.5s;
              flex-direction: row-reverse;
              color: #868686;
            }
            .icon-part a {
              width: 20px;
              height: 20px;
              margin: 0 5px;
            }
            .icon-part a:nth-child(2),
            .icon-part a:nth-child(3),
            .icon-part a:nth-child(4) {
              display: none;
            }
            .icon-part:hover {
              width: auto;
              transition: all 0.5s;
            }
            .icon-part:hover a:nth-child(2),
            .icon-part:hover a:nth-child(3),
            .icon-part:hover a:nth-child(4) {
              display: block;
            }
            .icon-part a:hover {
              color: #670f7a;
            }
            @media screen and (max-width: 400px) {
              .w-160 {
                width: 100%;
              }
              .h-186 {
                height: 400px;
              }
            }
            @media screen and (max-width: 400px) {
              .w-160 {
                width: 100%;
              }
              .h-186 {
                height: 400px;
              }
              .team_main {
                background-position: 543px;
              }
            }
            @keyframes myanim {
              from {
                background-size: cover;
              }
              to {
                background-size: cover;
              }
            }
          `}</style>
          <div className="team_main relative  h-600 md:h-700 md:flex md:items-center py-12p">
            <div id="stars" />
            <div id="stars2" />
            <div id="stars3" />
            <div className="container h-full md:h-auto">
              <div className="relative z-10 flex flex-col flex-wrap justify-start md:justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
                <h1 className=" text-white uppercase font-black text-10vw md:text-72 leading-none">
                  Our <span className="block text-green">Team</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className={`bg-gray-light z-12222`}>
          <div className={`image-left-block py-30 container`}>
            <h2 className={'text-purple text-24 font-black uppercase'}>Welcome</h2>
            <div className="flex flex-wrap">
              <div className="w-full md:w-50p mt-30">
                <picture>
                  <source media="(min-width:768px)" srcSet="/images/team/founders_group_photo.png" type="image/png" />
                  <source media="(max-width:768px)" srcSet="/images/team/founders_group_photo.png" type="image/png" />
                  <img src="" width={539} height={303} alt="founders" />
                </picture>
              </div>
              <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                We are happy to introduce you to the digital enthusiasts’ team, who create a better digital experience for our partners every day. A
                team, where doing result-oriented work and being time-efficient is our number one priority. As Steve Jobs once said, “Great things in
                business are never done by one person; they're done by a team of people”. In Prodigi, there is a team of professionals behind every
                project, who simply love their job. And, as the founders of Prodigi, we are happy that we could create a company, where work isn’t
                just a responsibility. It’s an opportunity to create and continuously develop great projects.
              </div>
            </div>
          </div>
        </div>
        <div className={`bg-white z-12222`}>
          <div className={`image-left-block py-30 container`}>
            <h2 className={'text-purple text-24 font-black uppercase'}>meet our team</h2>
            <div className="flex flex-wrap mt-30 justify-between md:justify-start">
              <div className={'parent-container-1 relative mr-0 md:mr-15 w-160 md:w-256 h-186 md:h-296 mb-10 '}>
                <div className="icon-part">
                  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} viewBox="0 0 20 20" fill="currentColor">
                    <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                  </svg>
                  <a href="https://www.facebook.com/BorisSahakyan" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/in/boris-sahakyan-3243364b/" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                  {/*<a href="" target="_blank">*/}
                  {/*    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 24 24"  fill="currentColor">*/}
                  {/*        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>]*/}
                  {/*    </svg>*/}
                  {/*</a>*/}
                </div>
                <div className={'w-full h-full element-image '} style={{ backgroundImage: `url(/images/team/boris1.png)` }}>
                  <div
                    className={'w-full h-full  element-image element-hover'}
                    style={{
                      backgroundImage: `url(/images/team/boris2.png)`,
                    }}
                  />
                  <div
                    className={'w-full h-full  element-image element-for-hover'}
                    style={{
                      backgroundImage: `url(/images/team/boris2.png)`,
                    }}
                  />
                </div>
                <div className="bottom-gradient">
                  <div className="w-full text-16 leading-20 font-800 text-gray-light absolute bottom-30 text-center name capitalize">
                    boris sahakyan
                  </div>
                  <div className="w-full text-16 leading-20 text-gray-light absolute bottom-10 text-center position capitalize">Co-Founder</div>
                </div>
              </div>
              <div className={'parent-container-2 relative mr-0 md:mr-15 w-160 md:w-256 h-186 md:h-296 mb-10 '}>
                <div className="icon-part">
                  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} viewBox="0 0 20 20" fill="currentColor">
                    <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                  </svg>
                  <a href="https://www.facebook.com/aidvopyan" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/in/aida-vopyan/" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                </div>
                <div className={'w-full h-full element-image'} style={{ backgroundImage: `url(/images/team/aida.png)` }}>
                  <div
                    className={'w-full h-full  element-image element-hover'}
                    style={{
                      backgroundImage: `url(/images/team/aida2.png)`,
                    }}
                  />
                  <div
                    className={'w-full h-full  element-image element-for-hover'}
                    style={{
                      backgroundImage: `url(/images/team/aida2.png)`,
                    }}
                  />
                </div>
                <div className="bottom-gradient">
                  <div className="w-full text-16 leading-20 font-800 text-gray-light absolute bottom-30 text-center name capitalize">aida vopyan</div>
                  <div className="w-full text-16 leading-20 text-gray-light absolute bottom-10 text-center position capitalize">CEO & Co-Founder</div>
                </div>
              </div>
              <div className={'parent-container-3 relative w-160 md:w-256 h-186 md:h-296 mb-10'}>
                <div className="icon-part">
                  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} viewBox="0 0 20 20" fill="currentColor">
                    <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                  </svg>
                  <a href="https://www.facebook.com/arsen.sultanyan" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17} viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                    </svg>
                  </a>
                  <a href="https://www.linkedin.com/in/arsensultanyan/" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </a>
                </div>
                <div className={'w-full h-full element-image'} style={{ backgroundImage: `url(/images/team/arsen1.png)` }}>
                  <div
                    className={'w-full h-full  element-image element-hover'}
                    style={{
                      backgroundImage: `url(/images/team/arsen2.png)`,
                    }}
                  />
                  <div
                    className={'w-full h-full  element-image element-for-hover'}
                    style={{
                      backgroundImage: `url(/images/team/arsen2.png)`,
                    }}
                  />
                </div>
                <div className="bottom-gradient">
                  <div className="w-full text-16 leading-20 font-800 text-gray-light absolute bottom-30 text-center name capitalize">
                    arsen sultanyan
                  </div>
                  <div className="w-full text-16 leading-20 text-gray-light absolute bottom-10 text-center position capitalize">Co-Founder</div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap mt-30 justify-between md:justify-start">
              {members.map((member, ind) => {
                return (
                  <div
                    key={'team_member' + ind}
                    className={`parent-container-${ind + 5} relative w-160 md:w-256 h-186 md:h-296 my-10  mr-0 md:mr-15`}
                  >
                    <div className="icon-part">
                      <svg xmlns="http://www.w3.org/2000/svg" width={18} height={19} viewBox="0 0 20 20" fill="currentColor">
                        <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                      </svg>
                      {member.facebook && (
                        <a href={member.facebook} target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17} viewBox="0 0 24 24" fill="currentColor">
                            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                          </svg>
                        </a>
                      )}
                      {member.linkedIn && (
                        <a href={member.linkedIn} target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                          </svg>
                        </a>
                      )}
                      {member.instagram && (
                        <a href={member.instagram} target="_blank">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                        </a>
                      )}
                    </div>
                    <div className={'w-full h-full element-image'} style={{ backgroundImage: `url(${member['new_landing_avatar']})` }}>
                      <div
                        className={'w-full h-full  element-image element-hover'}
                        style={{
                          backgroundImage: `url(${member['new_landing_avatar_hover']})`,
                        }}
                      />
                      <div
                        className={'w-full h-full  element-image element-for-hover'}
                        style={{
                          backgroundImage: `url(${member['new_landing_avatar_hover']})`,
                        }}
                      />
                    </div>
                    <div className="bottom-gradient">
                      <div className="w-full text-16 leading-20 font-800 text-gray-light    text-center name">{member['name']}</div>
                      <div className="w-full text-16 leading-20 text-gray-light pb-10  text-center position">{member['position']}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <LazyLoad>
          <div className={`bg-gray-light z-12222`}>
            <div className={`image-left-block py-30 container`}>
              <h2 className={'text-purple text-24 font-black uppercase'}>Management Team</h2>
              <div className="flex flex-wrap">
                <div className="w-full md:w-50p mt-30">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/team/managers_group.png" type="image/png" />
                    <source media="(max-width:768px)" srcSet="/images/team/managers_group.png" type="image/png" />
                    <img src="" width={539} height={303} alt="managers" />
                  </picture>
                </div>
                <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                  Collaborations have become more complex, but success still depends on the fundamentals. The foundation of every great team is a
                  direction that energizes, orients, and engages its members. And the directors are the company’s managers. Our top management team
                  has a mission to value the time of our partners and colleagues. It’s exactly this mission that connects our leaders, who create new
                  technologies and solutions to make Prodigi better every day. Our well-designed services are based on close departmental
                  collaborations, from the account managers to the financial department. Our top management team ensures clear, effective
                  communication, operative problem-solving, goal-setting and realization for the improvement and development of the company. And part
                  of our policy is the continuous development of our head of departments’ management skills.
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad>
          <div className={`bg-white z-12222`}>
            <div className={`image-right-block py-30 container`}>
              <h2 className={'text-purple text-24 font-black uppercase'}>Account management team</h2>
              <div className="flex flex-wrap flex-col-reverse md:flex-row">
                <div className="w-full md:w-50p mt-30 ">
                  Ask any of our clients what is the primary reason for becoming partners with us? And you will get the same answer every time. We
                  build good business with good relationships. Loyalty and transparency are always hard to win, but our account management department
                  strives to nurture and maintain a game-changing business relationship with all of our customers. Thus, we have strong client
                  relationships and dedicated partnerships. Unlike the sales role, our account managers have more profound primary aspirations. That
                  is to maintain the partnership and expand opportunities with 24/7 support. And they accomplish these aspirations by determining what
                  goals the clients have and helping them throughout the process of their achievement. Our experienced account team acts as a
                  long-term liaison for strategic partnerships and achieves their set goals by precise determination and well-defined perception.
                </div>
                <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/team/accounts-group_images5.png" type="image/png" />
                    <source media="(max-width:768px)" srcSet="/images/team/accounts-group_images5.png" type="image/png" />
                    <img src="" width={539} height={303} alt="accounts" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad>
          <div className={`bg-gray-light z-12222`}>
            <div className={`image-left-block py-30 container`}>
              <h2 className={'text-purple text-24 font-black uppercase'}>Digital project management team</h2>
              <div className="flex flex-wrap">
                <div className="w-full md:w-50p mt-30">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/team/PM-group_images.png" type="image/png" />
                    <source media="(max-width:768px)" srcSet="/images/team/PM-group_images.png" type="image/png" />
                    <img src="" width={539} height={303} alt="PM" />
                  </picture>
                </div>
                <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                  To introduce the project management team in our digital agency, we usually compare them with the management of an orchestra. Every
                  musician is a separate virtuoso, but to play together they need harmony, which is ensured by the conductor. In a digital agency, the
                  function of the conductor is done by the digital project managers, who unite the marketing specialists, videographers, animators,
                  storyboarders, script writers, and any other specialists needed for the project, and ensure harmony in all circles to create a
                  fantastic project. With our professional project managers, you can be sure that your project is in safe hands and ready to attract
                  your target audience.
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad>
          <div className={`bg-white z-12222`}>
            <div className={`image-right-block py-30 container`}>
              <h2 className={'text-purple text-24 font-black uppercase'}>production team</h2>
              <div className="flex flex-wrap flex-col-reverse md:flex-row">
                <div className="w-full md:w-50p mt-30 ">
                  <span className={'text-purple'}>Passion + Production = Performance</span> - is the formula that guides our in-house team of graphic
                  designers, animators, web developers and sound designers. Everything you need to know about our Production department: 13-year
                  professional background, advanced knowledge of 25+ production softwares (Adobe Photoshop, Illustrator, Animator, After Effects,
                  InDesign, Figma, Corel Draw, etc.), numerous designs for 30+ industries, 3 times daily brainstorming and an incessant desire to
                  learn new tools. As an American producer, David O. Selznick says: "The success of a production depends on the attention paid to
                  details," so paying attention to details is the key point of our team's workflow - from sketch to final design. Thus, our production
                  team is ready to contribute to your business and create result- oriented design materials for your brand too.
                </div>
                <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/team/production-group_images.png" type="image/png" />
                    <source media="(max-width:768px)" srcSet="/images/team/production-group_images.png" type="image/png" />
                    <img src="" width={539} height={303} alt="production" />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        <LazyLoad>
          <div className={`bg-gray-light z-12222`}>
            <div className={`image-right-block py-30 container`}>
              <h2 className={'text-purple text-24 font-black uppercase'}>social media team</h2>
              <div className="flex flex-wrap">
                <div className="w-full md:w-50p mt-30 ">
                  <picture>
                    <source media="(min-width:768px)" srcSet="/images/team/SMM-group_images.png" type="image/png" />
                    <source media="(max-width:768px)" srcSet="/images/team/SMM-group_images.png" type="image/png" />
                    <img src="" width={539} height={303} alt="SMM" />
                  </picture>
                </div>
                <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">
                  Social media is about the people! The mission of social media managers is to find user-oriented solutions. That is why our SMM
                  professionals use the full capacity of their knowledge to attract every projects’ and business’ target audience. In our social media
                  team, you will find professionals for LinkedIn, Facebook, Instagram, Snapchat, and Twitter, who invest their creative and analytic
                  abilities into every project and ensure fantastic results. One of the greatest achievements is our SMM managers’ professional
                  certification, one of which is the Facebook Blueprint Certification. Our company’s fastest-growing team is the social media team,
                  which creates more worldwide social media projects as time goes on.
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
        {/*<div className={`bg-white`}>*/}
        {/*    <div className={`image-left-block py-30 container`}>*/}
        {/*        <h1 className={'text-purple text-24 font-black uppercase'}>sales team</h1>*/}
        {/*        <div className="flex flex-wrap">*/}
        {/*            <div className="w-full md:w-50p mt-30 ">*/}
        {/*                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum*/}
        {/*                has been the industry's standard dummy text ever since the 1500s, when an unknown*/}
        {/*                printer took a galley of type and scrambled it to make a type specimen book. It has*/}
        {/*                survived not only five centuries, but also the leap into electronic typesetting,*/}
        {/*                remaining essentially unchanged.*/}
        {/*                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum*/}
        {/*                has been the industry's standard dummy text ever since the 1500s, when an unknown*/}
        {/*                printer took a galley of type and scrambled it to make a type specimen book. It has*/}
        {/*                survived not only five centuries, but also the leap into electronic typesetting,*/}
        {/*                remaining essentially unchanged.*/}
        {/*                Lorem Ipsum is simply dummy text of the printing and typesetting industry.*/}
        {/*            </div>*/}
        {/*            <div className="w-full md:w-50p mt-30 pl-0 md:pl-30">*/}
        {/*                <picture>*/}
        {/*                    <source media="(min-width:768px)" srcSet="/images/team/sales_group_images.png"*/}
        {/*                            type="image/png"/>*/}
        {/*                    <source media="(max-width:768px)" srcSet="/images/team/sales_group_images.png"*/}
        {/*                            type="image/png"/>*/}
        {/*                    <img src="" width={539} height={303} alt=""/>*/}
        {/*                </picture>*/}
        {/*            </div>*/}

        {/*        </div>*/}
        {/*    </div>*/}
        {/*</div>*/}
        <LazyLoad>
          <div className="bg-white bg-grid ">
            <div className="relative">
              <div className="flex flex-col-reverse md:flex-row">
                <div className="bg-fixed fix-elem  w-full  lg:w-30p bg-center bg-cover pt-15 md:pt-0  min-h-400 md:h-500 relative bg-purple">
                  <div className={'absolute right-0 md:-right-150 bottom-0 z-50'}>
                    <div className={'absolute top-42p left-34p flex items-center'}>
                      <div className="letter-i flex flex-col">
                        <div className={'ball-bounce'} />
                        <div className={'rectangle-for-resize'} />
                      </div>
                      <span className={'font-bold text-36 text-white'}>n</span>
                    </div>
                    <picture>
                      <source media="(min-width:768px)" srcSet="/images/team/Valera2.webp" type="image/png" />
                      <source media="(max-width:768px)" srcSet="/images/team/Valera2.webp" type="image/png" />
                      <img width={283} height={340} src="" className="hide" alt={'personage  Valera'} />
                    </picture>
                  </div>
                </div>
                <div className="w-auto md:w-full pb-30 md:pb-0  lg:w-60p h-220 md:h-500 flex flex-col justify-start md:justify-center items-start md:items-center ml-30 md:ml-0 mt-30 md:mt-0 ">
                  <div className={'text-36 md:text-48 text-black leading-35 md:leading-59 font-black uppercase'}>
                    <span className={'text-purple'}>We are on</span> <br /> Linkedin
                  </div>
                  <div className="mt-12 ml-0 md:-ml-140 h-40 w-154">
                    <span className="perspective-1000 contact">
                      <a href="https://www.linkedin.com/company/weprodigiagency/people/" target="_blank" className={' findUs  inline-block '} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LazyLoad>
      </main>
    </>
  );
};
export default Team;
